interface RecapIconProps {
  className?: string;
}

export function RecapIcon({ className = "h-8 w-8" }: RecapIconProps) {
  return (
    <svg 
      width="64" 
      height="64" 
      viewBox="0 0 64 64" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="64" height="64" rx="12" fill="#0D9488"/>
      <path d="M20 16C18.8954 16 18 16.8954 18 18V46C18 47.1046 18.8954 48 20 48H44C45.1046 48 46 47.1046 46 46V18C46 16.8954 45.1046 16 44 16H20Z" fill="white"/>
      <path d="M22 22H42V26H22V22Z" fill="#0D9488"/>
      <path d="M22 30H42V32H22V30Z" fill="#0D9488"/>
      <path d="M22 34H35V36H22V34Z" fill="#0D9488"/>
      <path d="M22 38H38V40H22V38Z" fill="#0D9488"/>
      <circle cx="48" cy="16" r="8" fill="#F59E0B"/>
      <path d="M44 16L46.5 18.5L52 13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
